import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { removeBlank } from 'src/app/core/helpers';
import { ApiService } from '../../../core/services/api.service';
import { DashboardData } from '../interface';


@Injectable({ providedIn: 'root' })
export class DashboardService extends ApiService {
  public dashboardStatusSubject = new ReplaySubject<DashboardData>(1);
  public getDashboardStats(query): Observable<DashboardData> {
    return this.request({
      path: 'dashboard/stats',
      method: 'GET',
      query: removeBlank(query),
    }).pipe(
      tap((stats) => {
        this.dashboardStatusSubject.next(stats);
      })
    );
  }

  public getDashboardData(): Observable<any> {
    return this.request({
      path: 'dashboard',
      method: 'GET',
    });
  }

    public getTest(params?): Observable<any> {
      return this.request({
        path: 'dashboard/tests',
        method: 'GET',
        query: removeBlank(params)
      });
    }



}
